import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';

import { negocio } from '../../conexiones';
import IFiltrosProveedores from './entidades/filtrosProveedores';
import IProveedores from './entidades/proveedores';

class ModeloProveedores {
    public consultarProveedores() {
        return manejadorRest<IRespuesta<IProveedores>>(() => negocio.get('Proveedor/ConsultarListaProveedor'));
    }

    public crearProveedores(proveedores: IProveedores) {
        return manejadorRest<IRespuesta<IProveedores>>(() => negocio.post('Proveedor/GuardarProveedor', proveedores));
    }

    public editarProveedores(proveedores: IProveedores) {
        return manejadorRest<IRespuesta<IProveedores>>(() => negocio.put('Proveedor/EditarProveedor', proveedores));
    }

    public eliminarProveedores(proveedores: IProveedores) {
        return manejadorRest<IRespuesta<IProveedores>>(() =>
            negocio.delete('Proveedor/EliminarProveedores', proveedores)
        );
    }

    public consultarListaProveedoresPorFiltro(filtrosProveedores: IFiltrosProveedores) {
        return manejadorRest<IRespuesta<IProveedores>>(() =>
            negocio.post('Proveedor/ConsultarListaProveedorePorFiltro', filtrosProveedores)
        );
    }
}

export default ModeloProveedores;
